import { ServiceMaker, methods, services } from "../services";

export const currencySetupList = () =>
    ServiceMaker(
        `/wallet/resource-master/list`,
        methods.GET,
        services.master,
    );

export const currencyViewDetail = id =>
    ServiceMaker(
        `/wallet/resource-master/detail/${id}`,
        methods.GET,
        services.master,
    );

export const deleteCurrency = Id =>
    ServiceMaker(
        `/wallet/resource-master/delete/${Id}`,
        methods.DELETE,
        services.master
    );

export const AddCurrency = payload =>
    ServiceMaker(
        `/wallet/resource-master/create`,
        methods.POST,
        services.master,
        payload
    );

export const editCurrency = payload =>
    ServiceMaker(
        `/wallet/resource-master/update?_id=${payload._id}`,
        methods.POST,
        services.master,
        payload
    );
